
import createIconComponent from '../utils/createIconComponent';
import { SVG_PROTECTED_FILLED } from '../../../dist';
import React from 'react';
const ProtectedFilledIcon = createIconComponent({ content: SVG_PROTECTED_FILLED, height: 24, width: 24 });
ProtectedFilledIcon.displayName = 'ProtectedFilledIcon';
export default ProtectedFilledIcon;
